var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { attrs: { id: "help-center" } }, [
    _c("div", { staticClass: "help-center-container" }, [
      _c("div", { staticClass: "help_details" }, [
        _c("h1", [_vm._v(_vm._s(_vm.helpCenterText.title))]),
        _vm._v(" "),
        _c("span", [
          _vm._v(
            "\n        " +
              _vm._s(_vm.replaceText(_vm.helpCenterText.text1)) +
              "\n      "
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "contact_container" },
          [
            _c("div", { staticClass: "contact_list" }, [
              _c("img", {
                attrs: { src: "images/credit-card-ui/email.png", alt: "email" },
              }),
              _vm._v(" "),
              _c("p", [
                _vm._v(_vm._s(_vm.replaceText(_vm.helpCenterText.text2))),
              ]),
            ]),
            _vm._v(" "),
            _vm.isImmersiLearn ||
            _vm.isXRLab360 ||
            _vm.isTheNextGenXR ||
            _vm.isVirtuPaths ||
            _vm.isXRLAB
              ? _c("div", { staticClass: "contact_list" }, [
                  _c("img", {
                    attrs: {
                      src: "images/credit-card-ui/phone-call.png",
                      alt: "phone",
                    },
                  }),
                  _vm._v(" "),
                  _c("p", [_vm._v(_vm._s(_vm.helpCenterText.text3))]),
                ])
              : _vm._e(),
            _vm._v(" "),
            !_vm.isXRStudios
              ? [
                  !_vm.isXRLab360
                    ? _c("div", { staticClass: "contact_list" }, [
                        _c("img", {
                          attrs: {
                            src: "images/credit-card-ui/phone-call.png",
                            alt: "phone",
                          },
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.helpCenterText.text4))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXRLab360
                    ? _c("div", { staticClass: "contact_list" }, [
                        _c("img", {
                          attrs: {
                            src: "images/credit-card-ui/phone-call.png",
                            alt: "phone",
                          },
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.helpCenterText.text5))]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.isXRLab360
                    ? _c("div", { staticClass: "contact_list" }, [
                        _c("img", {
                          attrs: {
                            src: "images/credit-card-ui/phone-call.png",
                            alt: "phone",
                          },
                        }),
                        _vm._v(" "),
                        _c("p", [_vm._v(_vm._s(_vm.helpCenterText.text6))]),
                      ])
                    : _vm._e(),
                ]
              : _vm._e(),
          ],
          2
        ),
        _vm._v(" "),
        _vm.msisdnPresent
          ? _c(
              "div",
              { staticClass: "Unsub_btn", on: { click: _vm.unsubscribe } },
              [_c("span", [_vm._v(_vm._s(_vm.helpCenterText.text7))])]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.showErrorMessage
          ? _c("p", { staticStyle: { color: "red", "font-size": "12px" } }, [
              _vm._v("\n        " + _vm._s(_vm.errorMessage) + "\n      "),
            ])
          : _vm._e(),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }